import { useMediaQuery } from "@mantine/hooks";

/**
 * The app sets :root font-size to 62.5% (1rem = 10px), which shrinks every
 * Mantine component (they size themselves in rem). To keep the forms at a
 * comfortable, readable scale we override sizes here in absolute px, which are
 * immune to the root font-size scaling.
 */

const BRAND = "#3439a5";
const BORDER = "#c0c0c9";
const LABEL = "#47474d";

export const MODAL_MAX_WIDTH = 620;

export const useIsMobile = () => useMediaQuery("(max-width: 600px)");

export const modalStyles = {
  content: { borderRadius: 16 },
  header: {
    padding: "20px 24px 14px",
    borderBottom: "1px solid #eef0f4",
    marginBottom: 4,
  },
  title: { fontSize: 21, fontWeight: 700, color: BRAND },
  close: { width: 34, height: 34, color: "#7a7a80" },
  body: { padding: 24 },
} as const;

export const fieldStyles = {
  label: {
    fontSize: 15,
    fontWeight: 600,
    color: LABEL,
    marginBottom: 7,
  },
  required: { fontSize: 15 },
  input: {
    height: 50,
    minHeight: 50,
    fontSize: 16,
    borderRadius: 10,
    borderColor: BORDER,
    paddingLeft: 14,
    paddingRight: 14,
  },
  error: { fontSize: 13, marginTop: 4 },
} as const;

export const multiSelectStyles = {
  ...fieldStyles,
  input: { ...fieldStyles.input, height: "auto", paddingLeft: 6 },
  values: { minHeight: 50 },
  value: { fontSize: 14, height: 30, borderRadius: 8 },
  item: { fontSize: 15, padding: "10px 12px" },
  dropdown: { borderRadius: 12 },
} as const;

export const primaryBtnStyles = {
  root: {
    height: 50,
    fontSize: 16,
    fontWeight: 700,
    borderRadius: 10,
    paddingLeft: 24,
    paddingRight: 24,
  },
} as const;

export const secondaryBtnStyles = {
  root: {
    height: 50,
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 10,
    paddingLeft: 24,
    paddingRight: 24,
  },
} as const;
